module.exports = __webpack_public_path__ + "static/media/shoe_03.05012577.jpg";